//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AnimationDesigner.js";
import "../AnimationDesigner/AnimationDesigner.PhysicsJointBuilder.js";
let d=[[[0,"AxisVector",1,"Direction",0],[0,"OrientationVector",1,"Direction",0],[0,"PointOnCurve",1,"Point",0],[0,"UseOrientationVector",1,0]],[[["n_curves"],"GetConnectedCurves",{R_:{curves:"NXObject[]"}},0,0],[["curves"],"SetConnectedCurves",{},1,0],[["curves"],"EvaluatePath",{},1,0]],[]];
SPLM.AnimationDesigner.PointOnCurveJointBuilder = class extends SPLM.AnimationDesigner.PhysicsJointBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AnimationDesigner.PointOnCurveJointBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;